import React from 'react';
import {store} from '../football_stats.jsx';

function getLeagueTableHeader(onlyLeague, ligaAlText, ligaLeumitText, currentLeague) {
    let html = '';

    if(typeof onlyLeague !== 'undefined' && onlyLeague === 719) {
        html = <div className={"liga-leumit-header pointer " + ((currentLeague == 719) ? "selected" : "")} onClick={(e) => (store.dispatch({type: "SET_CURRENT_LEAGUE", val: 719}))}> { ligaLeumitText } </div>
    } else if (typeof onlyLeague === 'undefined') {
     html = <div>
                <div className={"liga-al-header pointer " + ((currentLeague == 902) ? "selected" : "")} onClick={(e) => (store.dispatch({type: "SET_CURRENT_LEAGUE", val: 902}))}> { ligaAlText } </div>
                <div className={"liga-leumit-header pointer "+ ((currentLeague == 719) ? "selected" : "")} onClick={(e) => (store.dispatch({type: "SET_CURRENT_LEAGUE", val: 719}))}> { ligaLeumitText } </div>
            </div>
    }

    return html;
}

const LeagueTableWidget = ({
    standings,
    currentLeague,
    regularSeasonEnd,
    regularSeasonEndLeumit,
    leumitDisclaimer,
    disclaimer,
    onlyLeague,
}) =>  {

     let standingsArr = [];
     let standingsArrLower = [];

     // let ligaAlText =  getByLang('Ligat Ha\'al', 'ליגת העל','الدوري الممتاز');
     let ligaLeumitText = getByLang('Leumit League', 'ליגה לאומית','Leumit League');

    let ligaAlText =  getByLang('Ligat Winner', 'ליגת Winner','الدوري الممتاز');

     let ligaAlChampionshipText = '';
     let ligaAlRelegationText = '';
     let ligaLeumitChampionshipText = '';
     let ligaLeumitRelegationText = '';
     let disclaimerHtml = '';

     if(typeof standings != 'undefined') {
        if(!regularSeasonEnd) {
            ligaAlText = ligaAlText + ' ' + getByLang('Round','מחזור','جولة') + ' ' + (currentRound[902]['RegularSeason']);
            if(currentLeague == 902) {
                standingsArr = standings[currentLeague].RegularSeason;
                standingsArrLower = [];
            }
        } else {
            ligaAlChampionshipText = getByLang('Top Playoff Round','פלייאוף עליון מחזור','جولة') + ' ' + parseInt(parseInt(currentRound['902']['ChampionshipRound']) + 26);
            ligaAlRelegationText = getByLang('Top Playoff Round','פלייאוף תחתון מחזור','جولة') + ' ' + parseInt(parseInt(currentRound['902']['RelegationRound']) + 26);
            if(currentLeague == 902) {
                standingsArr = standings[currentLeague].ChampionshipRound;
                standingsArrLower = standings[currentLeague].RelegationRound;
            }
        }

        if(!regularSeasonEndLeumit) {
            ligaLeumitText = ligaLeumitText + ' ' +  getByLang('Round','מחזור','جولة') + ' ' + (currentRound[719]['RegularSeason']);
            if(currentLeague == 719) {
                standingsArr = standings[currentLeague].RegularSeason;
                standingsArrLower = [];
            }
        } else {
            ligaLeumitChampionshipText = getByLang('Top Playoff Round','פלייאוף עליון מחזור','') + ' ' + parseInt(currentRound['719']['PromotionGroup'] + 30);
            ligaLeumitRelegationText = getByLang('Top Playoff Round','פלייאוף תחתון מחזור','') + ' ' + parseInt(currentRound['719']['RelegationRound'] + 30);
            if(currentLeague == 719) {
                standingsArr = standings[currentLeague].PromotionGroup;
                standingsArrLower = standings[currentLeague].RelegationRound;
            }
        }

        if(leumitDisclaimer != "" && currentLeague == 719) {
            disclaimerHtml = leumitDisclaimer;
        }

        if(disclaimer != "" && currentLeague == 902) {
             disclaimerHtml = disclaimer;
        }
    }

    return (
    <div class="section2">
           <div id="tableHeader">
               { getLeagueTableHeader(onlyLeague, ligaAlText, ligaLeumitText, currentLeague) }
            </div>

            <div id={((currentLeague == 902 && regularSeasonEnd) || (currentLeague == 719 && regularSeasonEndLeumit)) ? "league-table-upper" : "league-table"} >
                {
                    currentLeague == 902 && regularSeasonEnd &&
                    <div className="subTableHeader">{ligaAlChampionshipText}</div>
                }
                {
                    currentLeague == 719 && regularSeasonEndLeumit &&
                    <div className="subTableHeader">{ligaLeumitChampionshipText} </div>
                }
                <div className="pointsTable">
                <ul className="pointsTableRow pointsTableHeader">
                    <li className="pointsTablePoints">{ is_mobile ? "#" : getByLang('Position','מיקום','')}</li>
                    <li className="pointsTableName">{getByLang('Team','קבוצה','')}</li>
                    <li className="pointsTablePoints">{is_mobile ? getByLang('G','מש',''): getByLang('Games','משחקים','')}</li>
                    <li className="pointsTablePoints">{is_mobile ? getByLang('W','נצ','') : getByLang('Win','נצחונות','')}</li>
                    <li className="pointsTablePoints">{is_mobile ? getByLang('D','תק','') : getByLang('Draw','תיקו','')}</li>
                    <li className="pointsTablePoints">{is_mobile ? getByLang('L','הפ','') : getByLang('Loss','הפסדים','')}</li>
                    <li className={ "pointsTablePoints" + (is_mobile ? " hidden" : "")}>{getByLang('For','זכות','')}</li>
                    <li className={ "pointsTablePoints" + (is_mobile ? " hidden" : "")}>{getByLang('GA','חובה','')}</li>
                    <li className="pointsTablePoints">{is_mobile ? getByLang('GD','ה״ש','') : getByLang('Diff','הפרש','')}</li>
                    <li className="pointsTablePoints">{is_mobile ? getByLang('P','נק','') : getByLang('points','נקודות','')}</li>
                </ul>
                    {
                        typeof standingsArr != 'undefined' && standingsArr.map((key,index) =>
                            <ul className="pointsTableRow">
                                 <li className="pointsTablePoints">{key.position}</li>
                                 <li className="pointsTablePoints">{getByLang(key.name, key.hebrewName, key.arabicName)}</li>
                                 <li className="pointsTablePoints">{key.gamesCount}</li>
                                 <li className="pointsTablePoints">{key.wins}</li>
                                 <li className="pointsTablePoints">{key.draws}</li>
                                 <li className="pointsTablePoints">{key.losses}</li>
                                 <li className={ "pointsTablePoints" + (is_mobile ? " hidden" : "")}>{key.goalsScored}</li>
                                 <li className={ "pointsTablePoints" + (is_mobile ? " hidden" : "")}>{key.goalsReceived}</li>
                                 <li className="pointsTablePoints">{key.goalsScored-key.goalsReceived}</li>
                                 <li className="pointsTablePoints">{key.points}</li>
                            </ul>
                        )
                    }
                    </div>
               </div>

        {
            standingsArrLower.length > 0 &&

            <div id="league-table-lower">
                {
                    currentLeague == 902 && regularSeasonEnd &&
                    <div className="subTableHeader">{ligaAlRelegationText}</div>
                }
                {
                    currentLeague == 719 && regularSeasonEndLeumit &&
                    <div className="subTableHeader">{ligaLeumitRelegationText} </div>
                }
                <div className="pointsTable">
                    <ul className="pointsTableRow pointsTableHeader">
                        <li className="pointsTablePoints">{ is_mobile ? "#" : getByLang('Position','מיקום','')}</li>
                        <li className="pointsTableName">{getByLang('Team','קבוצה','')}</li>
                        <li className="pointsTablePoints">{is_mobile ? getByLang('G','מש',''): getByLang('Games','משחקים','')}</li>
                        <li className="pointsTablePoints">{is_mobile ? getByLang('W','נצ','') : getByLang('Win','נצחונות','')}</li>
                        <li className="pointsTablePoints">{is_mobile ? getByLang('D','תק','') : getByLang('Draw','תיקו','')}</li>
                        <li className="pointsTablePoints">{is_mobile ? getByLang('L','הפ','') : getByLang('Loss','הפסדים','')}</li>
                        <li className={ "pointsTablePoints" + (is_mobile ? " hidden" : "")}>{getByLang('For','זכות','')}</li>
                        <li className={ "pointsTablePoints" + (is_mobile ? " hidden" : "")}>{getByLang('GA','חובה','')}</li>
                        <li className="pointsTablePoints">{is_mobile ? getByLang('GD','ה״ש','') : getByLang('Diff','הפרש','')}</li>
                        <li className="pointsTablePoints">{is_mobile ? getByLang('P','נק','') : getByLang('points','נקודות','')}</li>
                    </ul>
                    {
                        typeof standingsArrLower != 'undefined' && standingsArrLower.map((key,index) =>
                            <ul className="pointsTableRow">
                                <li className="pointsTablePoints">{currentLeague == 719 ? key.position + 8 : key.position + 6}</li>
                                <li className="pointsTablePoints">{getByLang(key.name,key.hebrewName,key.arabicName)}</li>
                                <li className="pointsTablePoints">{key.gamesCount}</li>
                                <li className="pointsTablePoints">{key.wins}</li>
                                <li className="pointsTablePoints">{key.draws}</li>
                                <li className="pointsTablePoints">{key.losses}</li>
                                <li className={ "pointsTablePoints" + (is_mobile ? " hidden" : "")}>{key.goalsScored}</li>
                                <li className={ "pointsTablePoints" + (is_mobile ? " hidden" : "")}>{key.goalsReceived}</li>
                                <li className="pointsTablePoints">{key.goalsScored-key.goalsReceived}</li>
                                <li className="pointsTablePoints">{key.points}</li>
                            </ul>
                        )
                    }
                </div>
            </div>
        }

        {
            disclaimerHtml &&
            <label className="table-disclaimer">{disclaimerHtml}</label>
        }
        </div>

    )
};

export default LeagueTableWidget;
